export const throttle = <T extends (...args: any[]) => void>(fn: T, delay: number): ((...args: Parameters<T>) => void) => {
    let lastTime = 0;
    let timeoutId: ReturnType<typeof setTimeout> | null = null;
    let lastArgs: Parameters<T> | null = null;

    return (...args: Parameters<T>): void => {
        const now = Date.now();
        const remaining = delay - (now - lastTime);
        lastArgs = args;

        if (remaining <= 0) {
            if (timeoutId) {
                clearTimeout(timeoutId);
                timeoutId = null;
            }

            lastTime = now;
            fn(...lastArgs);
            lastArgs = null;
        } else if (!timeoutId) {
            timeoutId = setTimeout(() => {
                lastTime = Date.now();
                timeoutId = null;

                if (lastArgs) {
                    fn(...lastArgs);
                    lastArgs = null;
                }
            }, remaining);
        }
    };
};
